export default __webpack_public_path__ + "static/media/alert1.58684d6f.mp3";